module.exports = __webpack_public_path__ + "img/sidebar.b00a9890.svg";